// Centralized hero/section image URLs — images hébergées localement dans /assets/

export const HERO_IMAGES = {
  ecole:        "/assets/hero-ecole.jpg",
  formations:   "/assets/hero-formations.jpg",
  admissions:   "/assets/hero-admissions.jpg",
  contact:      "/assets/hero-contact.jpg",
  pourquoiNous: "/assets/hero-pourquoi-nous.jpg",
  partenaires:  "/assets/hero-partenaires.jpg",
  entreprises:  "/assets/business-handshake.jpg",
  nosValeurs:   "/assets/hero-nos-valeurs.jpg",
  president:    "/assets/president-herve-diaz.jpg",
  legal:        "/assets/hero-legal.jpg",
  privacy:      "/assets/hero-privacy.jpg",
};

export default HERO_IMAGES;
